module.exports = __webpack_public_path__ + "media/images/svg/clients/2-d6d10299b766652217c14fc6045a592d.svg";